import { combineReducers } from "redux";

const RootReducers = combineReducers({
  login: require("../Reducers/Login").reducer,
  loginv2: require("../Reducers/LoginV2").reducer,
  resendOTP: require("../Reducers/ResendOTP").reducer,
  verifyOtp: require("../Reducers/VerifyOtp").reducer,
  register: require("../Reducers/Register").reducer,
  clinic: require("../Reducers/Clinic").reducer,
  edc: require("../Reducers/Edc").reducer,
  edcDOB: require("../Reducers/edcMemberVerifyWithDOB").reducer,
  registerEdc: require("../Reducers/RegisterEdc").reducer,
  getDiagnostic: require("../Reducers/GetDiagnostic").reducer,
  checkoutPayment: require("../Reducers/CheckoutPayment").reducer,
  claimItem: require("../Reducers/ClaimItem").reducer,
  calculateItem: require("../Reducers/CalculateItem").reducer,
  transaction: require("../Reducers/GetAllTransaction").reducer,
  filterTransaction: require("../Reducers/GetFilterTransaction").reducer,
  perTransaction: require("../Reducers/GetPerTransactionAll").reducer,
  perTransactionFilter: require("../Reducers/GetPerTransactionFilter").reducer,
  createTransaction: require("../Reducers/CreateTransaction").reducer,
  void: require("../Reducers/VoidClaim").reducer,
  inquiry: require("../Reducers/InquiryPayment").reducer,
  search: require("../Reducers/SearchTransaction").reducer,
  icd: require("../Reducers/GetIcdAll").reducer,
  icdSearch: require("../Reducers/IcdSearch").reducer,
  verify: require("../Reducers/VerifyUser").reducer,
  getUser: require("../Reducers/GetAllUser").reducer,
  getUserByProviderName: require("../Reducers/GetUserByProviderId").reducer,
  changePassword: require("../Reducers/ChangePassword").reducer,
  forgotPassword: require("../Reducers/ForgotPassword").reducer,
  getClaimLock: require("../Reducers/GetClaimLock").reducer,
  putClaimLock: require("../Reducers/PutClaimLock").reducer,
  biometrics: require("../Reducers/Biometrics").reducer,
  changeLang: require("../Reducers/ChangeLang").changeLang,
  captcha: require("../Reducers/Captcha").reducer,
  captchaV2: require("../Reducers/CaptchaV2").reducer,
  verifyCaptcha: require("../Reducers/VerifyCaptcha").reducer,
  OneInPayment: require("../Reducers/AllinOnePayment").reducer,
  docForm: require("../Reducers/DocForm").reducer,
  eligibilityFone: require("../Reducers/EligibilityFone").reducer,
  registerFone: require("../Reducers/RegisterFone").reducer,
  exclusionFone: require("../Reducers/ExclusionFone").reducer,
  ssoFone: require("../Reducers/FoneSSO").reducer,
  submitClaimFone: require("../Reducers/SubmitClaimFone").reducer,
  isLogin: require("../Reducers/isLogin").reducer,
  changeUsername: require("../Reducers/ChangeUsername").reducer,
  fingerPrintRegis: require("../Reducers/Fingerprint").reducer,
  checkSession: require("../Reducers/CheckSession").reducer,
  fingerPrintMatch: require("../Reducers/FingerPrintMatch").reducer,
  fingerPrintCard: require("../Reducers/FingerPrintMatchByCard").reducer,
  fingerPrintUnid: require("../Reducers/FingerPrintByUNID").reducer,
  uploadClaimCashless: require("../Reducers/UploadClaimCashless").reducer,
  invoiceList: require("../Reducers/InvoiceList").reducer,
  claimList: require("../Reducers/ClaimList").reducer,
  claimStatus: require("../Reducers/ClaimStatus").reducer,
  claimInvoice: require("../Reducers/CreateInvoice").reducer,
  deleteClaim: require("../Reducers/DeleteDocClaim").reducer,
  deleteId: require("../Reducers/IdData").reducer,
  claimListPending: require("../Reducers/ClaimListPending").reducer,
  claimPendingDetail: require("../Reducers/ClaimDetail").reducer,
  specility: require("../Reducers/Speciality").reducer,
  specilityStatus: require("../Reducers/SpecialityStatus").reducer,
});

export default RootReducers;
